import React, { useEffect } from 'react';
import CheckIcon from 'assets/icons/success.svg';
import XIcon from 'assets/icons/x.svg';
import './Alert.css';
import { useAlert } from './useAlert';
import { QuickNote } from './QuickNote';

const DEFAULT_TIMEOUT = 10000;
export const QUICK_NOTE_ALERT = 'quick_note';

const VIEW_BY_TYPE = {
  [QUICK_NOTE_ALERT]: QuickNote,
};

export const Alert = () => {
  const { alert, hideAlert } = useAlert();

  useEffect(() => {
    let timeoutId;
    if (alert) {
      const { timeout = DEFAULT_TIMEOUT } = alert;
      timeoutId = setTimeout(() => {
        hideAlert();
      }, timeout);
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [alert, hideAlert]);

  if (!alert) {
    return null;
  }
  const { content, type } = alert;

  const AlertView = type && VIEW_BY_TYPE[type];
  if (AlertView) {
    return <AlertView>{content}</AlertView>;
  }

  return (
    <div className="alerts">
      <div className="alert">
        <div className="icon">
          <img alt="check" src={CheckIcon} />
        </div>
        <div className="text">
          {content}
        </div>
        <div
          className="close"
          onClick={() => {
            hideAlert();
          }}
        >
          <img alt="close" src={XIcon} />
        </div>
      </div>
    </div>
  );
};
